module.exports = __webpack_public_path__ + "img/hr-level3addon_mining_tool_shadow-1.677151ef.png";